"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendItemsExtra = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var hierarchy_of_arrays_1 = require("../../layout/viewmodel/hierarchy_of_arrays");
var partition_spec_1 = require("./partition_spec");
var tree_1 = require("./tree");
exports.getLegendItemsExtra = re_reselect_1.default([partition_spec_1.getPartitionSpec, get_settings_specs_1.getSettingsSpecSelector, tree_1.getTrees], function (spec, _a, trees) {
    var legendMaxDepth = _a.legendMaxDepth;
    return spec && !Number.isNaN(legendMaxDepth) && legendMaxDepth > 0
        ? hierarchy_of_arrays_1.getExtraValueMap(spec.layers, spec.valueFormatter, trees[0].tree, legendMaxDepth)
        : new Map();
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_legend_items_extra.js.map